/* Landing page copy, English.
 *
 * THIS IS THE FILE TO EDIT. Every string here shows up on /landing exactly as
 * written. Save, and the running dev server repaints the page.
 *
 * Keys run in page order, top to bottom, under the headings below.
 * The other languages sit in src/utils/translations.js under their own locale.
 * A key missing from a locale falls back to the English written here, so a
 * half-translated language still renders.
 */
const landingEn = {

  // ============ HERO  (very top of the page) ============
  'landing.heroTitle': 'From first words to real conversations.',
  'landing.heroSubtitle': 'A speech practice app for kids who find talking hard, guided by Timo.',
  'landing.ctaGetStarted': 'Get started',
  'landing.heroStat1Big': '400+',
  'landing.heroStat1Label': 'parents used it',
  'landing.heroStat2Big': '3 modes',
  'landing.heroStat2Label': 'for every child',
  'landing.heroStat3Label': 'made in Lithuania',

  // ============ RADIO STRIP  (the thin line under the hero) ============
  'landing.radioMention': 'We were on national radio.',
  'landing.radioLinkText': 'Žinių radijas',

  // ============ THE THREE CARDS ============
  'landing.promiseTitle': 'Screen time that gives back.',
  'landing.promiseBody': 'Instead of scrolling, your child plays with Timo and practises the phrases real life needs, just 10min a day',
  'landing.card1Title': 'Tap to Speak',
  'landing.modeNonverbalDesc': 'Your child taps a picture and Timo says it out loud. No reading. Perfect for nonverbal and speech delayed kids. No reading required.',
  'landing.card3Title': 'Take care of Timo',
  'landing.modeLiveDesc': 'A game, not a lesson. Kids feed Timo, put him to bed and keeps him happy. To help him, they have to say what he needs, and that is practice that feels like play.',
  'landing.card2Title': 'Talk with Timo',
  'landing.modeChatDesc': 'Practise real conversations with Timo. Asking for help, joining a game. Timo helps along the way',

  // ============ HOW IT WORKS  (three numbered steps) ============
  'landing.howItWorks': 'How it works',
  'landing.howStep1Title': 'Tap a picture',
  'landing.howStep1Body': 'Your child clicks what they want to say and Timo says it out loud.',
  'landing.howStep2Title': 'Practise with Timo',
  'landing.howStep2Body': 'The same phrases come back as a conversation with Timo, so saying them feels normal before real life.',
  'landing.howStep3Title': 'Play and grow',
  'landing.howStep3Body': 'Looking after Timo turns practice into a game they come back to, and it becomes natural to ask for things',

  // ============ ORANGE BAND  (full-width, between the steps and the tiles) ============
  'landing.problemTitle': 'You know there is more they want to say.',
  'landing.problemBody': 'Maybe the words are still coming. Maybe they are all there and disappear the moment it matters: a new person, a loud room, a question they freeze on.',

  // ============ WHAT ELSE IS INSIDE  (three tiles) ============
  'landing.whatWeBuilt': 'What else is inside:',
  'landing.featWordTitle': 'Word of the day',
  'landing.featWordDesc': 'One new word a day, waiting in Timo\'s house. Your child hears it, says it back, and keeps it in their own list of words.',
  'landing.featScriptsTitle': 'Phrases you can keep',
  'landing.featScriptsDesc': 'Save the sentences that work: the ones for the shop, the classroom, the doctor. Practise one before you walk in, and it is there the next time.',
  'landing.featBreathingTitle': 'Calm-down breathing',
  'landing.featBreathingDesc': 'A guided breathing exercise for the moments it all gets too loud, so your child can reset and come back to it. (BETA)',

  // ============ PARENTS LOVE IT  (the two quotes) ============
  'landing.parentsLoveIt': 'Parents love it.',
  'landing.testimonialAlt1Quote': 'A truly great idea - this app should be shown to specialists in schools and kindergartens.',
  'landing.testimonialAlt1Name': 'Katrina S.',
  'landing.testimonialAlt1Author': 'Parent, Lithuania',
  'landing.testimonialAlt2Quote': 'Wonderful idea. Working with people who cannot speak, this app would truly help.',
  'landing.testimonialAlt2Name': 'Vida K.',
  'landing.testimonialAlt2Author': 'Specialist working with nonverbal adults',

  // ============ ARTICLES RAIL  (the small label above each cover) ============
  'landing.artCat1': 'First words',
  'landing.artCat2': 'Nonverbal',
  'landing.artCat3': 'Autism',
  'landing.artCat4': 'Anxiety',
  'landing.artCat5': 'Choosing an app',

  // ============ FOUNDER BLOCK ============
  'landing.ourStory': 'Why we built this',
  'landing.founderName': 'Gintaras',
  'landing.founderQuote': 'My brother has Asperger\'s. I built the first version for him, so the moments other people find easy would stop being the hard part of his day.',
  'landing.founderStory': 'Then I met a father whose son could not speak at all, and we built tap to speak: your child taps, the app says it out loud. After that I kept meeting kids with late speech who were still working on their first words, so I turned the whole thing into a game. Practising should feel like playing, not like homework.',
  'landing.founderRole': 'Founder of Timo Helps',

  // ============ LONG READ  (the collapsed block above the FAQ) ============
  'landing.longTitle': 'A speech practice app that fits into a normal day',
  'landing.longP1': 'Timo Helps (aka Time To Talk) is a communication and speech practice app for children who find talking hard: kids with a speech delay, nonverbal and minimally speaking kids, autistic kids, kids with ADHD, and children who talk freely at home but freeze at school, at the doctor or in a shop. It runs in the browser on a phone, a tablet or a laptop, so there is nothing to install and nothing to wait for.',
  'landing.longP2': 'It works in three ways. Tap to Speak is a picture board: your child taps what they want to say and the app says it out loud, so they have a voice on the first day, with no reading and no typing. Talk with Timo is a practice conversation with a gentle character who never rushes and never corrects them in front of anyone, so the sentences for ordering food, asking for help or joining a game get rehearsed somewhere safe first. Take care of Timo turns all of it into a game: children feed him, put him to bed and keep him happy, and to do any of that they have to say what he needs.',
  'landing.longP3': 'Around those three there is a word of the day, a place to keep the phrases that actually work for your family, a guided breathing exercise for the moments it gets too loud, and awards that mark progress without turning practice into homework. The app is available in Lithuanian, English, Russian and Spanish.',
  'landing.longP4': 'Timo Helps does not replace a speech and language therapist. It is the practice in between: open at 7am or at bedtime, supported with therapists plan. It was built in Lithuania by a founder whose own brother went quiet around new people, and it is used today by more than 400 families. 11.49 EUR a month, cancel anytime, no ads, and nothing about your child sold to anyone.',
  'landing.readMore': 'Read more',
  'landing.readLess': 'Show less',

  // ============ FAQ  (eleven rows) ============
  'landing.faqSectionTitle': 'People often ask',
  'landing.faq1Question': 'Who is Timo for?',
  'landing.faq1Answer': 'Kids from about age 3 and up: kids with a speech delay, nonverbal and minimally speaking kids, autistic kids, and any child who finds talking hard or freezes when it matters. Plenty of parents also use it for a child who simply needs practice putting everyday phrases together.',
  'landing.faq2Question': 'Does my child need to be able to read?',
  'landing.faq2Answer': 'No. Time To Talk (Timo Helps) uses pictures and icons. No persistant reading required.',
  'landing.faq3Question': 'What if it doesn\'t work for us?',
  'landing.faq3Answer': 'Cancel anytime from Profile, then Subscription. You keep access until the end of the month you have paid for.',
  'landing.faq4Question': 'Is our data safe?',
  'landing.faq4Answer': 'Yes. We never sell your data. Ever. Privacy first.',
  'landing.faq5Question': 'How much does it cost?',
  'landing.faq5Answer': '11.49 EUR a month for everything, on every device. No lock-in, cancel anytime.',
  'landing.faq6Question': 'What devices does it work on?',
  'landing.faq6Answer': 'It runs in the browser, so a phone, a tablet or a laptop all work with nothing to install. On a phone you can add it to the home screen and it opens like any other app. Read more how',
  'landing.faq7Question': 'What languages does it speak?',
  'landing.faq7Answer': 'Lithuanian, English, Russian and Spanish, BETA French, German, Norwegian. You pick one on the way in and can change it later in Settings.',
  'landing.faq8Question': 'Does this replace speech therapy?',
  'landing.faq8Answer': 'No, and it is not meant to. A therapist works on how your child produces speech. Timo gives them somewhere to practise between sessions, as often as they like.',
  'landing.faq9Question': 'How much time does it take?',
  'landing.faq9Answer': 'A few minutes is enough. No streaks, no daily targets, nothing that punishes a day off. Most families use it in short bursts: before the shop, after school, at bedtime.',
  'landing.faq10Question': 'Do I need to sit with my child?',
  'landing.faq10Answer': 'You can, and early on it helps. But it is built so a child can open it alone: everything is a picture, everything is tappable, and Timo does the reading.',
  'landing.faq11Question': 'How do we start?',
  'landing.faq11Answer': 'You answer a few questions about your child and the app sets itself up around their level and the situations you named. It takes a few minutes, and you can change any of it later.',

  // ============ FINAL CTA AND EVENT CODE  (bottom of the page) ============
  'landing.priceTeaserTitle': '11.49 EUR a month',
  'landing.priceTeaserBody': 'Less than a coffee a week. Every mode and every language included, cancel anytime.',
  'landing.ctaPlans': 'See plans',
  'landing.eventCodeTitle': 'Have a creator or event code?',
  'landing.eventCodePlaceholder': 'Enter event code',
  'landing.eventCodeCta': 'Apply code',
  'landing.eventCodeNote': 'One use per person. Misuse or sharing results in a ban.',

  // ============ TOP BAR, MENU AND FOOTER ============
  'landing.signIn': 'Log in',
  'landing.ctaTryTimo': 'Try Timo',

  /* ========================================================================
     Everything below belongs to the ORIGINAL landing page, the one still
     serving "/". None of it shows on /landing. Left here so that page keeps
     working: ignore it while writing the new copy.
  ======================================================================== */
  'landing.tryFree': 'Get Timo',
  'landing.cancelAnytime': 'Cancel anytime.',
  'landing.feature1Title': 'Tap to speak',
  'landing.feature1Desc': 'Your child taps a picture. Timo says it out loud.',
  'landing.feature2Title': 'Practise with Timo',
  'landing.feature2Desc': 'Real conversations, at their pace, with zero judgment.',
  'landing.feature3Title': 'Play together',
  'landing.feature3Desc': 'Care for Timo and practise asking for things, as a game.',
  'landing.quote': '"My son tapped the picture and the app said what he wanted. He looked at me like, did you hear that. We both cried."',
  'landing.quoteAuthor': 'Mother of a 7-year-old with autism, Lithuania',
  'landing.stayUpdated': 'Stay updated',
  'landing.stayUpdatedDesc': 'Get tips and stories from families like yours.',
  'landing.subscribe': 'Subscribe',
  'landing.subscribing': 'Sending...',
  'landing.subscribeSuccess': '✓ Thanks! Check your email soon.',
  'landing.navPricing': 'Try Timo',
  'landing.heroCtaPricing': 'Get started',
  'landing.storyIntro': 'We kept seeing the same thing',
  'landing.storyPoint1': 'Kids who understand everything and cannot get the words out.',
  'landing.storyPoint2': 'Some need pictures. Some need practice. Most need both.',
  'landing.storyPoint3': 'And most apps make them pick one and stick with it.',
  'landing.storyWeBuild': 'So we built one app that grows with your child.',
  'landing.modeNonverbal': 'Speak',
  'landing.modeChat': 'Practise',
  'landing.modeLive': 'Play',
  'landing.storyStats': '187 families using it',
  'landing.storyUsage': '86% use it daily',
  'landing.storyBuiltIn': 'Built in Lithuania',
  'landing.storyExpanding': 'Over 2026 we plan to expand across EU',
  'landing.storyTryButton': 'Get Timo →',
  'landing.heroCtaTry': 'Get Timo',
  'landing.heroCtaGet': 'Get Time To Talk',
  'landing.stats1Number': '130+',
  'landing.stats1Label': 'families signed up',
  'landing.stats2Number': '3 modes',
  'landing.stats2Label': 'for every child',
  'landing.stats3Number': '🇱🇹',
  'landing.stats3Label': 'made in Lithuania',
  'landing.modesTitle': 'Start where your child is today.',
  'landing.modesSubtitle': 'Give them the words for right now, then grow into real conversations with Timo.',
  'landing.modeNonverbalTitle': 'Tap to Speak',
  'landing.modeChatTitle': 'Talk with Timo',
  'landing.modeLiveTitle': 'Take care of Timo',
  'landing.modeLiveBadge': 'NEW',
  'landing.scrollHint': 'scroll',
  'landing.featAwardsTitle': 'Awards & progress',
  'landing.featAwardsDesc': 'Trophies celebrate every step, so practising communication feels like a game, not homework.',
  'landing.devBypassLogin': 'Dev bypass login',
  'landing.devBypassHome': 'Dev bypass to home',
  'landing.testimonialQuote': '"He used it the first day. He asked for water by himself. First time ever."',
  'landing.testimonialAuthor': 'Parent from Vilnius',
  'landing.founderTitle': 'Hi, I\'m Gintaras',
  'landing.founderHook': 'My brother has Asperger’s. I built the first version for him, so the moments other people find easy would stop being the hard part of his day.',
  'landing.founderProblemLabel': 'The problem',
  'landing.founderProblemText': 'Then I met a father whose son could not speak at all, and we built tap to speak: your child taps, the app says it out loud. After that I kept meeting kids with late speech who were still working on their first words, so I turned the whole thing into a game. Practising should feel like playing, not like homework.',
  'landing.founderSearchLabel': 'What I found',
  'landing.founderSearchText': 'I looked for apps to help. Everything I found was complicated and not useful.',
  'landing.founderBuildLabel': 'What I built at 16',
  'landing.founderBuildPoint1': 'Then I met a parent whose child literally could not say "I\'m hungry" or keep communication with loved ones.',
  'landing.founderBuildPoint2': 'Two different problems. Zero good solutions. I started building Time To Talk at 16.',
  'landing.founderBuildPoint3': 'Tap an icon and the app speaks. Practice conversations with no pressure. Get real-time conversation help when you freeze.',
  'landing.founderForWho': 'For everyone who needs help with conversations.',
  'landing.founderLine1': 'I watched my brother go silent every time someone new talked to him.',
  'landing.founderLine2': 'Teachers. Other kids. People outside.',
  'landing.founderLine3': 'He could speak fine at home. Put him anywhere else, and it was gone.',
  'landing.founderLine4': 'I looked for apps to help. Everything I found was complicated and not useful.',
  'landing.founderLine5': 'Then I met a parent whose child literally could not say "I\'m hungry" or keep communication with loved ones.',
  'landing.founderLine6': 'Two different problems. Zero good solutions. So I started building Time To Talk at 16: tap an icon and the app speaks, practice conversations without pressure, and get real-time help when you freeze. For everyone who needs help with conversations.',
  'landing.founderAttribution': 'Gintaras, Founder of Time To Talk',
  'landing.finalCtaTitle': 'Give them a way to be heard.',
  'landing.finalCtaSubtitle': 'Start today and see what your child says first.',
  'landing.finalCtaButton': 'Get Time To Talk',
  'landing.faqDropdownTitle': 'FAQ',
  'landing.pricingDropdownTitle': 'Pricing',
  'landing.priceIncreaseBanner': 'Founding rate ends in {timeLeft}',
  'landing.pricingTitle': 'Pricing.',
  'landing.ctaSeePlans': 'See my plan',
  'landing.stickyCta': 'Get Time To Talk',
  'landing.howTitle': 'How it works',
  'landing.priceTeaserCta': 'See plans',
};

export default landingEn;
